export class Point {
    constructor(x: number, y: number) {
        this.x = x;
        this.y = y;
    }

    x = 0;
    y = 0;
}

export class Line {
    point1: Point;
    point2: Point;
    constructor([x1, y1]: [number, number], [x2, y2]: [number, number]) {
        this.point1 = new Point(x1, y1);
        this.point2 = new Point(x2, y2);
    }
}
